import { render } from "./SurveyView.vue?vue&type=template&id=0b522ab0&scoped=true&ts=true"
import script from "./SurveyView.vue?vue&type=script&lang=ts"
export * from "./SurveyView.vue?vue&type=script&lang=ts"

import "./SurveyView.vue?vue&type=style&index=0&id=0b522ab0&scoped=true&lang=scss"

import exportComponent from "/opt/atlassian/pipelines/agent/build/SurveyPublic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b522ab0"]])

export default __exports__